import { render, staticRenderFns } from "./Hobbies.vue?vue&type=template&id=189beaf5&scoped=true&"
import script from "./Hobbies.vue?vue&type=script&lang=js&"
export * from "./Hobbies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189beaf5",
  null
  
)

export default component.exports